import $ from 'jquery';

// Bootstrap requirement
import 'popper.js';

// Bootstrap JS Modules add here
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';

import AnimatedHeader from './modules/animatedHeader';
import NavMenu from './modules/navMenu';
import ImageLoader from './modules/imageLoader';
import Fullpage from './modules/fullpageScroller';
import Carousel from './modules/carousel';

(function() {
	AnimatedHeader.init();
	NavMenu.init();
	ImageLoader.init();
	Carousel.init();

    if ($('.homepage ').length || $('.landing').length) {
    	new Fullpage('#fullpage');
    }
})();



// WEBPACK FOOTER //
// ./src/js/app.js